<template>
  <div
    class="step-menu-item"
    :class="{
      active: isActive,
      completed: isCompleted,
      disabled: isDisabled,
    }"
    @click="handleClick"
  >
    <div class="step-indicator">
      <template v-if="isCompleted">
        <feather-icon icon="CheckIcon" class="completed-icon" />
      </template>
      <template v-else>
        <span class="step-number">{{ step.number }}</span>
      </template>
    </div>

    <div class="step-info">
      <div class="step-title">{{ step.title }}</div>
      <small v-if="step.subtitle" class="step-subtitle text-muted">
        {{ step.subtitle }}
      </small>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    step: {
      type: Object,
      required: true,
      validator: (step) => {
        const valid = ["number", "title"].every((key) => key in step);
        if (!valid) {
          console.warn(
            "Objeto de etapa inválido passado para PromotionStepMenuItem. Chaves esperadas: number, title."
          );
        }
        return valid;
      },
    },
    currentStep: {
      type: Number,
      required: true,
    },
    completed: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    isActive() {
      return this.step.number === this.currentStep;
    },

    isCompleted() {
      return this.completed || this.step.number < this.currentStep;
    },

    isDisabled() {
      return this.completed && this.step.number > this.currentStep;
    },
  },

  methods: {
    handleClick() {
      if (!this.isDisabled) {
        this.$emit("click", this.step.number);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.step-menu-item {
  display: flex;
  align-items: center;
  padding: 0.75rem 1rem;
  margin-bottom: 0.5rem;
  border-radius: 0.5rem;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover:not(.disabled) {
    background-color: rgba(115, 103, 240, 0.1);
  }

  &.active {
    background-color: rgba(115, 103, 240, 0.15);
    .step-title {
      font-weight: 600;
      color: var(--primary);
    }
    .step-indicator {
      background-color: var(--primary);
      .step-number {
        color: white;
      }
    }
  }

  &.completed {
    .step-indicator {
      background-color: #28c76f;
    }
    .step-title {
      color: var(--success);
    }
  }

  &.disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
}

.step-indicator {
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 1rem;
  transition: all 0.3s ease;

  .step-number {
    font-weight: 600;
    color: #6c757d;
  }

  .completed-icon {
    color: white;
    width: 1rem;
    height: 1rem;
  }
}

.step-info {
  flex: 1;

  .step-title {
    transition: all 0.3s ease;
    margin-bottom: 0.1rem;
  }

  .step-subtitle {
    display: block;
    font-size: 0.75rem;
  }
}
</style>
